import { createFileRoute } from '@tanstack/react-router';
import { adReportStaticData } from '../index';

export const Route = createFileRoute('/_private-routes/tiktok/ad-campaign-report/$id/')({
  staticData: adReportStaticData
});
